import classNames from 'classnames';
import styles from './index.module.scss';

interface ColorSwatchProps {
    name: string;
    hex: string;
    checked: boolean;
    onChange: (name: string) => void;
}

const ColorSwatch = ({ name, hex, checked, onChange }: ColorSwatchProps) => {
    return (
        <button
            type="button"
            aria-pressed={checked}
            aria-label={name}
            title={name}
            onClick={() => onChange(name)}
            className={classNames(styles.swatch, { [styles.selected]: checked })}
        >
            <span className={styles.square} style={{ backgroundColor: hex }} />
            <span className={styles.underline} />
        </button>
    );
};

export default ColorSwatch;
